import { Employment } from '../../shared/models/employment.model';
import { Education } from '../../shared/models/education.model';
import { LinkedProfileDTO } from './profile-linkage.model';
import { ProgramFeeDiscountDetailDTO } from './program-fee-discount.model';
import { ProfileMonthlySubscriptionCancellation } from './profile-monthly-subscription-cancellation.mode';

export class Address {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  stateCode: string;
}

export class PhoneNumber {
  id: number;
  phoneNumber: string;
  extension: string;
  type: number;
  isPrimary: boolean;
  active: boolean;
}

export class Email {
  id: number;
  emailAddress: string;
  isPrimary: boolean;
  extension: string;
  type: number;
  active: boolean;
  candidateId?: number;
  internId?: string;
}

export class Intern {
  accessedByYouOn: Date;
  admitDate: Date;
  addresses: Address[];
  admittedThreshold: boolean;
  hasEducatorLicense: boolean;
  applicationDate: Date;
  campus: string;
  candidateId?: number;
  city: string;
  claimedOnStateWebsite: boolean = false;
  college: string;
  company: CompanyDTO;
  createUser: string;
  disqualificationReason?: string;
  district: string;
  dob: string;
  doNotEmail: boolean;
  educations: Education[];
  emailAddress: string;
  emails: Email[];
  employments: Employment[];
  ethnicity: string;
  federalBackgroundCheckDate: Date;
  fileLocation: number;
  financialStatusId: number | null;
  firstName: string;
  gender: string;
  hasValidConferredDate?: boolean;
  holdEndDate: Date | null;
  holdStartDate: Date | null;
  id: number;
  interviewDate: Date;
  internId: string;
  internNumber: string; // TODO: This field is deprecated. Instead, use internId or id.
  isExcludedFromHcl: boolean;
  isTrainingCompleted?: boolean;
  isMissouriReadyToCompleteProgram?: boolean;
  balanceThresholdForCompletion: number;
  isVip: boolean;
  lastName: string;
  lateHire: boolean;
  lateHireExpirationDate: Date;
  linkedProfiles?: LinkedProfileDTO[];
  maidenName: string;
  militaryStatusId?: number;
  middleName: string;
  sponsorshipMessage: string;
  modUser: string;
  objectId: string;
  offeredAdmitDate: Date;
  offeredAdmitDateExpired: boolean;
  paidDate: Date;
  phoneNumbers: PhoneNumber[];
  preferredName: string;
  profileId: number;
  profileIdentifier: string;
  program: string;
  programDiscountEligible: boolean;
  programPath: string;
  programId: number;
  programPathId: number;
  applicationPathIds: number[];
  race: string;
  referralIntern: string;
  referralSources: number;
  ruleset: string;
  sponsorName?: string;
  sponsorshipProfileId?: number;
  ssn: string;
  state: string;
  stateCode: string;
  stateHasConfigurableAgreements: boolean;
  stateId: number;
  stateLicenseId: string;
  status: string;
  statusId: number;
  statusReason?: string;
  suffix: string;
  thirdPartyId: number;
  trainingPathId: number;
  userEmailAddress: string;
  paymentProcessorId?: number;
  profileProgramFeeDiscount: ProgramFeeDiscountDetailDTO | null;
  profileMonthlySubscriptionCancellation: ProfileMonthlySubscriptionCancellation | null;
  deferredEligibilityGrantedDate: Date | null;
}
export class CompanyDTO {
  id: number;
  description: string;
  code: string;
}
